/**
 * CRM Context (minimal in Phase 1)
 *
 * Mounted in App.tsx's ModuleProviders so module state persists across
 * navigation, matching the platform module pattern (StudyOrganizer/Intelligence/
 * Ereg/IXVerify/MHR). Expanded in later phases (contacts, timeline, flows).
 * Auth and current site come from the shared AuthContext.
 */
import { createContext, useContext, ReactNode } from 'react';

interface CRMContextType {
  ready: boolean;
}

const CRMContext = createContext<CRMContextType | undefined>(undefined);

export function CRMProvider({ children }: { children: ReactNode }) {
  return <CRMContext.Provider value={{ ready: true }}>{children}</CRMContext.Provider>;
}

export function useCRM() {
  const ctx = useContext(CRMContext);
  if (ctx === undefined) {
    throw new Error('useCRM must be used within a CRMProvider');
  }
  return ctx;
}
